@if (visible) {
  <div class="ai-dock" [class.ai-dock--blocked]="blocked">
    <div class="ai-dock__header">
      <span class="ai-dock__badge" aria-hidden="true">
        <mat-icon>auto_awesome</mat-icon>
      </span>
      <span class="ai-dock__title">{{ 'activity.ai_adjustment.dock.title' | translate }}</span>
      <span class="ai-dock__beta">{{ 'activity.ai_adjustment.dock.beta' | translate }}</span>
      <span class="ai-dock__hint">{{ 'activity.ai_adjustment.dock.hint' | translate }}</span>

      @if (budgetRemaining !== null) {
        <span
          class="ai-dock__budget"
          [matTooltip]="'activity.ai_adjustment.dock.budget.tooltip' | translate: { date: (budgetResetsAt | i18n_date | async) }"
        >
          {{ 'activity.ai_adjustment.dock.budget.label' | translate: { percentage: budgetRemaining } }}
        </span>
      }
    </div>

    @if (blockedReason === 'quota_exhausted') {
      <p class="ai-dock__blocked-message">
        {{ 'activity.ai_adjustment.dock.budget.exhausted' | translate: { date: (budgetResetsAt | i18n_date | async) } }}
      </p>
    }

    <div class="ai-dock__composer" [class.ai-dock__composer--focused]="false">
      <label class="ai-dock__label" for="ai-adjustment-instruction">
        {{ 'activity.ai_adjustment.dock.instruction.label' | translate }}
      </label>
      <textarea
        #instructionInput
        id="ai-adjustment-instruction"
        class="ai-dock__input"
        rows="2"
        [attr.placeholder]="'activity.ai_adjustment.dock.instruction.placeholder' | translate"
        [(ngModel)]="instruction"
        [disabled]="disabled || blocked"
        (input)="autoGrow()"
      ></textarea>
      <button
        type="button"
        class="ai-dock__send"
        [disabled]="!canSubmit"
        [attr.aria-label]="'activity.ai_adjustment.dock.send' | translate"
        [matTooltip]="'activity.ai_adjustment.dock.send' | translate"
        (click)="submit()"
      >
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>

    @if (visionAvailable) {
      <div class="ai-dock__vision">
        <mat-checkbox
          color="primary"
          [checked]="useOrganizationVision"
          [disabled]="disabled || blocked"
          (change)="toggleVision($event.checked)"
        >
          {{ 'activity.ai_adjustment.dock.vision.label' | translate }}
        </mat-checkbox>

        <button type="button" class="ai-dock__vision-toggle" (click)="toggleVisionPreview()">
          {{ (visionPreviewOpen
            ? 'activity.ai_adjustment.dock.vision.hide'
            : 'activity.ai_adjustment.dock.vision.show') | translate }}
        </button>
      </div>
    }

    @if (visionPreviewOpen && organizationVision) {
      <p class="ai-dock__vision-preview">{{ organizationVision }}</p>
    }
  </div>
}
